<template>
  <div>
    <!-- <b-button size="sm" variant="outline-success" :to="{ name: 'admin-user' }">
      Voltar
    </b-button> -->

    <b-card>
      <b-tabs>
        <b-tab title="Clientes">
          <b-form class="custom-form" @submit.prevent>
            <b-row>
              <b-col md="12"></b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="username"
                    placeholder="Nome"
                    v-model="form.name"
                  />
                  <label for="username">Nome</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email"
                    placeholder="Email"
                    v-model="form.email"
                  />
                  <label for="username">Email</label>
                </div>
              </b-col>

              <b-col md="1">
                <div class="form-label-group">
                  <b-form-input
                    id="ddd"
                    placeholder="DDD"
                    v-model="form.phone.ddd"
                  />
                  <label for="ddd">DDD</label>
                </div>
              </b-col>
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="phone"
                    placeholder="Telefone"
                    v-model="form.phone.number"
                  />
                  <label for="phone">Telefone</label>
                </div>
              </b-col>
              <b-col md="2">
                <div class="form-label-group">
                  <b-form-input
                    id="cnpj_cpf"
                    placeholder="cnpj_cpf"
                    v-model="form.cnpj_cpf"
                  />
                  <label for="cnpj_cpf">cnpj_cpf</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="originsCode"
                    placeholder="Códigos de Origens"
                    v-model="form.originsCode"
                  />
                  <label for="originsCode">Códigos de Origens</label>
                </div>
              </b-col>
              <b-col class="mb-2" md="12"><hr /></b-col>
              <b-col md="12"></b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="contract"
                    placeholder="Contrato"
                    v-model="form.contract"
                  />
                  <label for="contract">Contrato</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="productId"
                    placeholder="Produto Id"
                    v-model="form.product_id"
                  />
                  <label for="productId">Produto Id</label>
                </div>
              </b-col>
              <b-col md="3">
                <div class="form-label-group">
                  <b-form-input
                    id="product"
                    placeholder="Produto"
                    v-model="form.product"
                  />
                  <label for="product">Produto</label>
                </div>
              </b-col>
                          
              <b-col class="mb-2" md="12"><hr /></b-col>

              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt_first_access"
                    placeholder="Data Primeiro Acesso"
                    v-model="form.dt_first_access"
                    disabled
                  />
                  <label for="dt_first_access">Data Primeiro Acesso</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt_last_access"
                    placeholder="Data Ultimo acesso"
                    v-model="form.dt_last_access"
                    disabled
                  />
                  <label for="dt_last_access">Data Ultimo acesso</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt-created"
                    placeholder="Data Criação"
                    v-model="form.data_inclusao"
                    disabled
                  />
                  <label for="dt-created">Data Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email-created"
                    placeholder="Email Criação"
                    v-model="form.email_create"
                    disabled
                  />
                  <label for="email-created">Email Criação</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt_update"
                    placeholder="Data Alteração"
                    v-model="form.dt_update"
                    disabled
                  />
                  <label for="dt_update">Data Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email_update"
                    placeholder="Email Alteração"
                    v-model="form.email_update"
                    disabled
                  />
                  <label for="email_update">Email Alteração</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="dt_delete"
                    placeholder="Data Deleção"
                    v-model="form.dt_delete"
                    disabled
                  />
                  <label for="dt_delete">Data Deleção</label>
                </div>
              </b-col>
              <b-col md="6">
                <div class="form-label-group">
                  <b-form-input
                    id="email_delete"
                    placeholder="Email Deleção"
                    v-model="form.email_delete"
                    disabled
                  />
                  <label for="email_delete">Email Deleção</label>
                </div>
              </b-col>
              <b-col>
                <b-button
                  type="submit"
                  variant="primary"
                  class="mr-1"
                  @click="onSubmit"
                >
                  Enviar
                </b-button>
                <b-button variant="danger" class="mr-1" @click="onBackPage">
                  Voltar
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-tab>
        <b-tab title="Sistemas">
          <user-client-register-system
            :clientId="form._id"
            ref="user-client-register-system"
            @submit-system-edit="onSubmitSystemEdit"
          ></user-client-register-system>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BForm,
  BButton,
  BTabs,
  BTab,
  BCard,
} from "bootstrap-vue";
import dropdownService from "@/providers/dropdownService";
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";
import messagesNotifyHelper from "@/helpers/messages-notify-helper";
// import vSelect from "vue-select";
import clientService from "@/providers/clientService";
import UserClientRegisterSystem from "./UserClientRegisterSystem.vue"
import AppConstants from '@/appConstants';

export default {
  props: {},
  data() {
    return {
      form: {
        _id: "",
        name: "",
        email: "",
        phone: {number: null, ddd: null},
        cnpj_cpf: "",
        originsCode: "",

        contract: "",
        product: "",
        product_id: "",

        dt_first_access: "",
        dt_last_access: "",

        dt_delete: "",
        dt_create: "",
        dt_update: "",

        email_create: "",
        email_update: "",
        email_delete: "",
        system_prop: []
      },
      logicalNumber: [],
      origins: [],
      country: [],
      wdma_route: [],
      subjects: []
    };
  },
  created() {
    this.$store.dispatch("admin/updatePageTitle", 'Novo Cliente');
    if (this.isUpdate) {
      this.dataID = this.$route.params.id;
      // console.log("dataid: ", this.dataID);
    }

    this.loadData();
  },
  computed: {
    isUpdate() {
      if (this.$route.params.id) {
        return true;
      }
      return false;
    },
  },
  watch: {
    "form.name"(val) {
      if (val) {
        this.$store.dispatch("admin/updatePageTitle", val);
      } else {
        this.$store.dispatch("admin/updatePageTitle", 'Novo Cliente');
      }
    },
    "form.country"(val) {
      console.log(val);
      this.form.language = val.language.name;
    },
  },
  methods: {
    onSubmitSystemEdit(val) {
      const index = this.form.system_prop.findIndex(item => item.origin.id == val.origin.id);
      if (index < 0) {
        val.origin['_id'] = val.origin.id
        this.form.system_prop.push(JSON.parse(JSON.stringify(val)))
      } else {
        this.form.system_prop[index] = JSON.parse(JSON.stringify(val));
      }
      this.$refs['user-client-register-system'].data = [];
      this.$refs['user-client-register-system'].data = JSON.parse(JSON.stringify(this.form.system_prop));
    },
    onBackPage() {
      this.$router.push(AppConstants.NAVIGATION_PAGE_ADM_USER_CLIENT);
    },
    onSubmit() {
      const sendForm = JSON.parse(JSON.stringify(this.form));
      sendForm.system_prop = sendForm.system_prop.map(item => {
        item.filters = item.filters.split(',');
        return item;
      });
      sendForm.originsCode = sendForm.originsCode.split(',');
      // console.log('send form: ', sendForm);
      clientService.registerClient(sendForm, new URLSearchParams()).then(() => {
        // console.log(res);
        if (this.isUpdate) {
          messagesNotifyHelper.updatedRecordNotify();
        } else {
          messagesNotifyHelper.createdRecordNotify();
          this.onBackPage();
        }
      });
    },
    getUserDetail() {
      const params = new URLSearchParams();
      clientService
        .getClientDetails(this.dataID, params)
        .then((res) => {
          // console.log(res);
          this.form._id = res._id;
          this.form.name = res.name;
          this.form.email = res.email;
          if (res.phone) {
            this.form.phone.ddd = res.phone.ddd;
            this.form.phone.number = res.phone.number;
          }
          this.form.cnpj_cpf = res.cnpj_cpf;
          this.form.originsCode = res.originsCode.toString();

          this.form.contract = res.contract;
          this.form.product = res.product;
          this.form.product_id = res.product_id;

          this.form.system_prop = res.system_prop;
          this.form.system_prop = this.form.system_prop.map(item => {
            item.filters = item.filters.toString();
            return item;
          });
          this.$refs['user-client-register-system'].data = JSON.parse(JSON.stringify(this.form.system_prop));
          // console.log(this.form.system_prop);
        
          this.form.dt_create = convertDatetimeHelper.convertStringToDateTime(
            res.dt_create
          );
          this.form.dt_update = res.dt_update
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_update)
            : res.dt_update;
          this.form.dt_delete = res.dt_delete
            ? convertDatetimeHelper.convertStringToDateTime(res.dt_delete)
            : res.dt_delete;
          this.form.email_create = res.email_create;
          this.form.email_update = res.email_update;
          this.form.email_delete = res.email_delete;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadData() {
      Promise.all([
        dropdownService.getAllOrigin(new URLSearchParams()),
        dropdownService.getAllCountries(new URLSearchParams()),
        dropdownService.getAllLogicalNumber(new URLSearchParams()),
        dropdownService.getAllSubjects(new URLSearchParams()),
      ])
        .then((res) => {
          this.origins = res[0];
          this.country = res[1];
          this.wdma_route = res[1];
          this.logicalNumber = res[2];
          this.push_notification = res[3];

          if (this.dataID) {
            this.getUserDetail();
          }
        })
        .catch((err) => console.log(err));
    },
  },
  components: {
    BButton,
    BRow,
    BCol,
    BFormInput,
    BForm,
    BTabs,
    BTab,
    BCard,
    UserClientRegisterSystem
  },
};
</script>

<style lang="scss">
</style>